import * as z from 'zod'

import {buildEntrySchemaFor} from '../entry'
import {FormFieldTextInputSchema} from './formFieldTextInput'
import {FormFieldTextAreaSchema} from './formFieldTextArea'
import {FormFieldSelectSchema} from './formFieldSelect'
import {FormFieldCheckboxGroupSchema} from './formFieldCheckboxGroup'

export const FormLayoutSchema = buildEntrySchemaFor('formLayout', {
  fields: z.lazy(() =>
    z.object({
      formFields: z
        .array(
          z
            .union([
              FormFieldTextInputSchema,
              FormFieldTextAreaSchema,
              FormFieldSelectSchema,
              FormFieldCheckboxGroupSchema,
            ])
            .readonly(),
        )
        .readonly(),
    }),
  ),
})

export type FormLayout = z.infer<typeof FormLayoutSchema>
